import { render } from "./OpportunityDetailSlideover.vue?vue&type=template&id=490c9bcc"
import script from "./OpportunityDetailSlideover.vue?vue&type=script&lang=js"
export * from "./OpportunityDetailSlideover.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__